import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckIcon, XIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const PIXEL_ID = '1462984295393644';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq && window.fbq.loaded) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const existingScript = document.querySelector('script[src="https://connect.facebook.net/en_US/fbevents.js"]');
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  if (!type) return null;
  const isPrivacy = type === 'privacy';
  const privacyContent = <>
      <p className="mb-4" data-id="element-2">Última actualización: enero 2025</p>
      <p className="mb-4" data-id="element-3">
        En <strong data-id="element-4">Libido Express</strong> nos comprometemos a proteger tu
        privacidad. Esta política describe cómo recopilamos, usamos y protegemos
        tu información personal.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-5">
        1. Información que recopilamos
      </h3>
      <p className="mb-4" data-id="element-6">
        Al realizar tu compra, recopilamos únicamente tu dirección de correo
        electrónico para enviarte el acceso a tu producto digital. No
        recopilamos información de pago directamente; esta es procesada de forma
        segura por nuestro proveedor de pagos.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-7">
        2. Uso de la información
      </h3>
      <p className="mb-4" data-id="element-8">
        Tu correo electrónico se utiliza exclusivamente para: (a) entregar tu
        producto digital, (b) enviarte comunicaciones relacionadas con tu
        compra. No vendemos, alquilamos ni compartimos tu información con
        terceros.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-9">3. Seguridad</h3>
      <p className="mb-4" data-id="element-10">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información. Toda la transmisión de datos se realiza
        mediante cifrado SSL.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-11">4. Cookies</h3>
      <p className="mb-4" data-id="element-12">
        Este sitio puede utilizar cookies técnicas necesarias para su
        funcionamiento. No utilizamos cookies de rastreo de terceros con fines
        publicitarios.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-13">5. Tus derechos</h3>
      <p className="mb-4" data-id="element-14">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tus
        datos personales en cualquier momento. Para ejercer estos derechos,
        puedes comunicarte con nosotros a través de los canales indicados en tu
        correo de confirmación de compra.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-15">
        6. Cambios a esta política
      </h3>
      <p data-id="element-16">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
  const termsContent = <>
      <p className="mb-4" data-id="element-17">Última actualización: enero 2025</p>
      <p className="mb-4" data-id="element-18">
        Al adquirir <strong data-id="element-19">Libido Express</strong>, aceptas los siguientes
        términos y condiciones. Por favor, léelos detenidamente antes de
        completar tu compra.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-20">
        1. Naturaleza del producto
      </h3>
      <p className="mb-4" data-id="element-21">
        Libido Express es un producto de información digital (eBook/PDF) de
        carácter educativo e informativo. No constituye consejo médico,
        diagnóstico ni tratamiento de ninguna condición de salud. Siempre
        consulta a un profesional de la salud antes de iniciar cualquier
        protocolo de bienestar.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-22">
        2. Acceso y entrega
      </h3>
      <p className="mb-4" data-id="element-23">
        Tras la confirmación de pago, recibirás acceso inmediato a tu producto
        digital. El acceso es personal e intransferible. No está permitida la
        redistribución, reventa o reproducción del contenido.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-24">
        3. Política de reembolso
      </h3>
      <p className="mb-4" data-id="element-25">
        Dado que se trata de un producto digital con acceso inmediato, no se
        ofrecen reembolsos una vez que el acceso ha sido entregado, salvo en
        casos de error técnico comprobable de nuestra parte.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-26">
        4. Propiedad intelectual
      </h3>
      <p className="mb-4" data-id="element-27">
        Todo el contenido de Libido Express, incluyendo textos, gráficos y
        metodologías, es propiedad exclusiva de sus autores y está protegido por
        las leyes de derechos de autor aplicables. Queda prohibida su
        reproducción total o parcial sin autorización expresa.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-28">
        5. Limitación de responsabilidad
      </h3>
      <p className="mb-4" data-id="element-29">
        Los resultados descritos son experiencias individuales y no garantizan
        resultados idénticos para todos los usuarios. La efectividad del
        protocolo puede variar según la situación personal de cada usuaria.
      </p>
      <h3 className="font-bold mb-2 mt-5 text-[#2d2d2d]" data-id="element-30">6. Ley aplicable</h3>
      <p data-id="element-31">
        Estos términos se rigen por las leyes aplicables en la jurisdicción del
        vendedor. Cualquier disputa será resuelta de buena fe entre las partes.
      </p>
    </>;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{
    background: 'rgba(45, 45, 45, 0.65)',
    backdropFilter: 'blur(4px)'
  }} onClick={onClose} data-id="element-32">
      <div className="relative w-full max-w-2xl max-h-[85vh] rounded-lg overflow-hidden flex flex-col" style={{
      background: '#fff9f7',
      fontFamily: 'Georgia, serif'
    }} onClick={e => e.stopPropagation()} data-id="element-33">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4 flex-shrink-0" style={{
        background: '#c4796a',
        color: 'white'
      }} data-id="element-34">
          <h2 className="text-xl font-bold" data-id="element-35">
            {isPrivacy ? 'Política de Privacidad' : 'Términos de Uso'}
          </h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center transition-colors hover:bg-white/20" aria-label="Cerrar" data-id="element-36">
            <XIcon className="w-5 h-5" data-id="element-37" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto px-6 py-6 text-sm leading-relaxed flex-1" style={{
        color: '#555'
      }} data-id="element-38">
          {isPrivacy ? privacyContent : termsContent}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 flex-shrink-0 text-center" style={{
        borderTop: '1px solid #f0e0dc',
        background: '#fff'
      }} data-id="element-39">
          <button onClick={onClose} className="px-8 py-2.5 rounded text-sm tracking-wide transition-opacity hover:opacity-90" style={{
          background: '#c4796a',
          color: 'white'
        }} data-id="element-40">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}
function useFadeIn() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.classList.add('visible');
        observer.unobserve(el);
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
}
function SectionDivider({
  text
}: {
  text: string;
}) {
  return <div className="text-center text-[13px] tracking-[3px] my-[10px] mb-[30px] uppercase" style={{
    color: '#c4796a'
  }} data-id="element-41">
      {text}
    </div>;
}
type FaqItem = {
  q: string;
  a: string;
};
function FaqAccordion({
  items
}: {
  items: FaqItem[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-0" data-id="element-42">
      {items.map((item, i) => <div key={i} className="border-b" style={{
      borderColor: '#f0e0dc'
    }} data-id="element-43">
          <button className="w-full flex items-center justify-between py-5 text-left transition-colors" style={{
        fontSize: '16px',
        color: '#2d2d2d'
      }} onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-44">
            <span className="font-semibold pr-4" data-id="element-45">{item.q}</span>
            {openIndex === i ? <ChevronUpIcon className="w-5 h-5 flex-shrink-0 text-[#c4796a]" data-id="element-46" /> : <ChevronDownIcon className="w-5 h-5 flex-shrink-0 text-[#c4796a]" data-id="element-47" />}
          </button>
          {openIndex === i && <div className="pb-5 text-[14px] leading-[1.6]" style={{
        color: '#666'
      }} data-id="element-48">
              {item.a}
            </div>}
        </div>)}
    </div>;
}
function scrollToOferta() {
  document.getElementById('oferta')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function LibidoExpressPage() {
  const heroRef = useFadeIn();
  const storyRef = useFadeIn();
  const problemRef = useFadeIn();
  const whyRef = useFadeIn();
  const diffRef = useFadeIn();
  const whatRef = useFadeIn();
  const whoRef = useFadeIn();
  const howRef = useFadeIn();
  const proofRef = useFadeIn();
  const faqRef = useFadeIn();
  const offerRef = useFadeIn();
  const [legalModal, setLegalModal] = useState<ModalType>(null);
  useEffect(() => {
    initFacebookPixel();
  }, []);
  const handleAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Libido Express',
        content_type: 'product',
        value: 5.55,
        currency: 'USD'
      });
    }
  };
  const faqItems: FaqItem[] = [{
    q: '¿Es seguro si estoy en la menopausia?',
    a: 'Sí. Diseñado específicamente para esta etapa. Si tienes condiciones médicas, consulta a tu médico antes de iniciar cualquier suplementación.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No. La mayoría están disponibles en supermercados o tiendas naturistas a precios accesibles.'
  }, {
    q: '¿Es un contenido discreto?',
    a: 'Totalmente. Tu compra aparece de forma privada en tu estado de cuenta. Acceso inmediato y personal.'
  }, {
    q: '¿Funciona si llevo años con este problema?',
    a: 'El protocolo trabaja con tu biología actual sin importar cuánto tiempo llevas experimentando estos cambios. Muchas mujeres notan diferencia desde la primera semana.'
  }];
  return <div className="w-full min-h-screen font-serif" style={{
    background: '#fff9f7',
    color: '#2d2d2d',
    fontFamily: 'Georgia, serif'
  }} data-id="element-49">
      {legalModal && <LegalModal type={legalModal} onClose={() => setLegalModal(null)} data-id="element-50" />}

      {/* TOP BAR */}
      <div className="sticky top-0 z-50 w-full py-[10px] px-4 text-center text-[14px] tracking-[1px]" style={{
      background: '#c4796a',
      color: 'white'
    }} data-id="element-51">
        🌸 Precio de Lanzamiento: Solo $5.55 USD — Acceso Instantáneo · Precio
        sube pronto
      </div>

      {/* HERO */}
      <section ref={heroRef} className="section-fade text-center pt-[60px] pb-[40px] px-5 max-w-[650px] mx-auto" data-id="element-52">
        <div className="text-[12px] tracking-[2px] mb-5" style={{
        color: '#c4796a'
      }} data-id="element-53">
          ✦ PROTOCOLO DIGITAL PARA MUJER MADURA ✦
        </div>
        <h1 className="text-[28px] sm:text-[36px] leading-[1.3] mb-[10px] text-[#2d2d2d]" data-id="element-54">
          Libido Express:
          <br data-id="element-55" />
          El Protocolo de Reconexión Íntima
          <br data-id="element-56" />
          para la Mujer 45+
        </h1>
        <div className="text-[18px] italic my-[15px] mb-[25px] leading-[1.6]" style={{
        color: '#6b4c4c'
      }} data-id="element-57">
          Para la mujer que siente que algo
          <br data-id="element-58" />
          se apagó por dentro
          <br data-id="element-59" />y está lista para encenderlo de nuevo.
        </div>
        <div className="text-[16px] mb-[35px] leading-[1.6]" style={{
        color: '#555'
      }} data-id="element-60">
          14 días. Natural. Sin fármacos.
          <br data-id="element-61" />
          Sin pretender que no está pasando.
        </div>

        <button onClick={scrollToOferta} className="inline-block py-[18px] px-[40px] text-[16px] rounded-[4px] cursor-pointer tracking-[1px] mb-[20px] transition-opacity hover:opacity-90 border-none" style={{
        background: '#c4796a',
        color: 'white',
        fontFamily: 'Georgia, serif'
      }} data-id="element-62">
          → QUIERO RECONECTARME — $5.55 USD
        </button>

        <div className="flex justify-center gap-5 flex-wrap text-[13px] my-[15px]" style={{
        color: '#888'
      }} data-id="element-63">
          <span data-id="element-64">🔒 Pago Seguro</span>
          <span data-id="element-65">⚡ Acceso Instantáneo</span>
          <span data-id="element-66">🌿 100% Natural</span>
          <span data-id="element-67">🔐 Privacidad Total</span>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/iSwh1sLt2pH6JsSnPocYPi/heylloyd-image-1772562227069.png" alt="Libido Express" className="max-w-full sm:max-w-[400px] mx-auto block rounded-[8px] mt-[30px]" data-id="element-68" />
      </section>

      {/* STORY */}
      <section ref={storyRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-69">
        <SectionDivider text="✦ TU HISTORIA ✦" data-id="element-70" />
        <div className="text-[18px] leading-[1.9] italic text-center mb-5" style={{
        color: '#4a3a3a'
      }} data-id="element-71">
          "Hay una conversación que llevas
          <br data-id="element-72" />
          meses evitando.
          <br data-id="element-73" />
          <br data-id="element-74" />
          No con tu pareja.
          <br data-id="element-75" />
          Contigo misma.
          <br data-id="element-76" />
          <br data-id="element-77" />
          Esa sensación de estar apagada
          <br data-id="element-78" />
          por dentro.
          <br data-id="element-79" />
          De querer querer... pero que tu cuerpo
          <br data-id="element-80" />
          simplemente no acompañe.
          <br data-id="element-81" />
          <br data-id="element-82" />
          De evitar el contacto no por falta
          <br data-id="element-83" />
          de amor, sino porque algo cambió
          <br data-id="element-84" />y nadie te dio el manual."
        </div>
        <div className="text-[18px] font-bold text-center leading-[1.8]" style={{
        color: '#2d2d2d'
      }} data-id="element-85">
          No estás sola.
          <br data-id="element-86" />
          No es culpa tuya.
          <br data-id="element-87" />
          Pero sí está en tus manos cambiarlo.
        </div>
      </section>

      {/* PROBLEM */}
      <section ref={problemRef} className="section-fade w-full py-[50px] px-5" style={{
      background: '#fff5f3'
    }} data-id="element-88">
        <div className="max-w-[650px] mx-auto" data-id="element-89">
          <SectionDivider text="✦ LO QUE NADIE TE DICE SOBRE LOS 45+ ✦" data-id="element-90" />
          <h2 className="text-[26px] text-center mb-[10px] text-[#2d2d2d]" data-id="element-91">
            Después de los 45, tu cuerpo
            <br data-id="element-92" />
            cambia las reglas del juego.
          </h2>
          <p className="text-center text-[16px] leading-[1.7] mb-[35px]" style={{
          color: '#555'
        }} data-id="element-93">
            Y el silencio que viene con ese cambio
            <br data-id="element-94" />
            es el peor enemigo
            <br data-id="element-95" />
            de tu bienestar íntimo.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[25px] mt-5" data-id="element-96">
            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-97">
              <div className="text-[28px] mb-[10px]" data-id="element-98">💧</div>
              <h3 className="text-[15px] mb-[8px] text-[#2d2d2d] font-bold" data-id="element-99">
                Esa sensación de incomodidad interna que nadie nombra pero
                muchas conocen
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-100">
                Cuando los cambios naturales de esta etapa afectan tu comodidad,
                tu respuesta y tus ganas de conectar.
              </p>
            </div>

            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-101">
              <div className="text-[28px] mb-[10px]" data-id="element-102">🌫️</div>
              <h3 className="text-[15px] mb-[8px] text-[#2d2d2d] font-bold" data-id="element-103">
                Sentirte desconectada de tu propio cuerpo
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-104">
                Como si habitaras un lugar que ya no reconoces del todo. Que no
                sientes completamente tuyo.
              </p>
            </div>

            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-105">
              <div className="text-[28px] mb-[10px]" data-id="element-106">🩹</div>
              <h3 className="text-[15px] mb-[8px] text-[#2d2d2d] font-bold" data-id="element-107">
                Lo que compraste en la farmacia no llegó a la raíz
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-108">
                Porque fue diseñado para el síntoma de afuera, no para tu
                biología completa de adentro.
              </p>
            </div>

            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-109">
              <div className="text-[28px] mb-[10px]" data-id="element-110">💔</div>
              <h3 className="text-[15px] mb-[8px] text-[#2d2d2d] font-bold" data-id="element-111">
                La culpa silenciosa de querer querer y que tu cuerpo no responda
                igual
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-112">
                Eso duele más que cualquier síntoma físico. Y lo sabes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WHY IT FAILED */}
      <section ref={whyRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-113">
        <SectionDivider text="✦ POR QUÉ LO QUE INTENTASTE NO FUNCIONÓ ✦" data-id="element-114" />
        <h2 className="text-[26px] text-center mb-[10px] text-[#2d2d2d]" data-id="element-115">
          No fallaste tú.
          <br data-id="element-116" />
          Fallaron las soluciones.
        </h2>
        <ul className="list-none mt-5" data-id="element-117">
          <li className="py-[15px] text-[16px] leading-[1.6] pl-[20px] relative" style={{
          borderBottom: '1px solid #f0e0dc',
          color: '#555'
        }} data-id="element-118">
            <span className="absolute left-0" style={{
            color: '#c4796a'
          }} data-id="element-119">
              →
            </span>
            Los lubricantes convencionales solo alivian el síntoma externo
            mientras la incomodidad interna sigue sin resolverse.
          </li>
          <li className="py-[15px] text-[16px] leading-[1.6] pl-[20px] relative" style={{
          borderBottom: '1px solid #f0e0dc',
          color: '#555'
        }} data-id="element-120">
            <span className="absolute left-0" style={{
            color: '#c4796a'
          }} data-id="element-121">
              →
            </span>
            Los suplementos genéricos no fueron creados para la biología
            específica de la mujer en esta etapa de su vida.
          </li>
          <li className="py-[15px] text-[16px] leading-[1.6] pl-[20px] relative" style={{
          borderBottom: '1px solid #f0e0dc',
          color: '#555'
        }} data-id="element-122">
            <span className="absolute left-0" style={{
            color: '#c4796a'
          }} data-id="element-123">
              →
            </span>
            Intentar forzarlo solo eleva tu cortisol — la hormona que bloquea
            exactamente la respuesta natural que buscas.
          </li>
          <li className="py-[15px] text-[16px] leading-[1.6] pl-[20px] relative" style={{
          borderBottom: '1px solid #f0e0dc',
          color: '#555'
        }} data-id="element-124">
            <span className="absolute left-0" style={{
            color: '#c4796a'
          }} data-id="element-125">
              →
            </span>
            Esperar a que pase solo no lo hace desaparecer. Solo hace crecer la
            distancia contigo misma y con tu pareja.
          </li>
        </ul>
      </section>

      {/* THE DIFFERENCE */}
      <section ref={diffRef} className="section-fade w-full py-[50px] px-5" style={{
      background: '#fff5f3'
    }} data-id="element-126">
        <div className="max-w-[650px] mx-auto" data-id="element-127">
          <SectionDivider text="✦ LA DIFERENCIA ✦" data-id="element-128" />
          <h2 className="text-[26px] text-center mb-[10px] text-[#2d2d2d]" data-id="element-129">
            El Método de Reconexión Bio-Natural
          </h2>
          <div className="rounded-[12px] p-[40px] text-center mt-5" style={{
          background: '#fff5f3'
        }} data-id="element-130">
            <p className="text-[16px] leading-[1.8] my-[15px]" style={{
            color: '#555'
          }} data-id="element-131">
              Este protocolo no tapa el síntoma.
              <br data-id="element-132" />
              <strong data-id="element-133">Trabaja desde adentro hacia afuera.</strong>
            </p>
            <p className="text-[16px] leading-[1.8] my-[15px]" style={{
            color: '#555'
          }} data-id="element-134">
              Con nutrientes específicos como el Omega-7 y técnicas de calma del
              sistema nervioso, tu cuerpo recibe exactamente lo que necesita
              para recuperar su respuesta natural desde la raíz biológica.
            </p>
            <p className="text-[17px] font-bold my-[15px]" style={{
            color: '#2d2d2d'
          }} data-id="element-135">
              No es magia.
              <br data-id="element-136" />
              Es tu biología, bien nutrida
              <br data-id="element-137" />
              por primera vez en mucho tiempo.
            </p>
            <p className="text-[16px] leading-[1.8] my-[15px]" style={{
            color: '#555'
          }} data-id="element-138">
              Sin fármacos.
              <br data-id="element-139" />
              Sin hormonas sintéticas.
              <br data-id="element-140" />
              Solo tu cuerpo haciendo
              <br data-id="element-141" />
              lo que siempre supo hacer.
            </p>
          </div>
        </div>
      </section>

      {/* WHAT YOU GET */}
      <section ref={whatRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-142">
        <SectionDivider text="✦ TODO LO QUE RECIBES HOY ✦" data-id="element-143" />
        <div className="mt-5" data-id="element-144">
          <div className="flex gap-5 py-5 items-start" style={{
          borderBottom: '1px solid #f0e0dc'
        }} data-id="element-145">
            <div className="text-[30px] min-w-[40px]" data-id="element-146">📖</div>
            <div data-id="element-147">
              <h3 className="text-[16px] mb-[5px] text-[#2d2d2d] font-bold" data-id="element-148">
                El Manual Digital "Libido Express"
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-149">
                Formato PDF de lectura rápida. Claro, directo y diseñado para
                que puedas empezar hoy mismo.
              </p>
            </div>
          </div>
          <div className="flex gap-5 py-5 items-start" style={{
          borderBottom: '1px solid #f0e0dc'
        }} data-id="element-150">
            <div className="text-[30px] min-w-[40px]" data-id="element-151">🌿</div>
            <div data-id="element-152">
              <h3 className="text-[16px] mb-[5px] text-[#2d2d2d] font-bold" data-id="element-153">
                El Protocolo de Nutrición de Mucosas
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-154">
                Lista de suplementos y alimentos clave para apoyar la
                hidratación natural de tus tejidos desde adentro.
              </p>
            </div>
          </div>
          <div className="flex gap-5 py-5 items-start" style={{
          borderBottom: '1px solid #f0e0dc'
        }} data-id="element-155">
            <div className="text-[30px] min-w-[40px]" data-id="element-156">🌬️</div>
            <div data-id="element-157">
              <h3 className="text-[16px] mb-[5px] text-[#2d2d2d] font-bold" data-id="element-158">
                La Técnica de Respiración Pélvica de 60 Segundos
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-159">
                Para reducir el bloqueo por estrés y abrir el espacio al
                bienestar íntimo natural.
              </p>
            </div>
          </div>
          <div className="flex gap-5 py-5 items-start" style={{
          borderBottom: '1px solid #f0e0dc'
        }} data-id="element-160">
            <div className="text-[30px] min-w-[40px]" data-id="element-161">📅</div>
            <div data-id="element-162">
              <h3 className="text-[16px] mb-[5px] text-[#2d2d2d] font-bold" data-id="element-163">
                El Plan de Acción de 14 Días
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-164">
                Para tu reconexión gradual, sin presión y sin expectativas
                artificiales. Con resultados reales y sostenibles.
              </p>
            </div>
          </div>
          <div className="flex gap-5 py-5 items-start" style={{
          borderBottom: '1px solid #f0e0dc'
        }} data-id="element-165">
            <div className="text-[30px] min-w-[40px]" data-id="element-166">💧</div>
            <div data-id="element-167">
              <h3 className="text-[16px] mb-[5px] text-[#2d2d2d] font-bold" data-id="element-168">
                Guía de Hidratación Externa Segura
              </h3>
              <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-169">
                Ingredientes naturales que funcionan de verdad, sin químicos
                agresivos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IS THIS FOR YOU */}
      <section ref={whoRef} className="section-fade w-full py-[50px] px-5" style={{
      background: '#fff5f3'
    }} data-id="element-170">
        <div className="max-w-[650px] mx-auto" data-id="element-171">
          <SectionDivider text="✦ ¿ES ESTO PARA TI? ✦" data-id="element-172" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[30px] mt-5" data-id="element-173">
            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-174">
              <h3 className="text-[15px] mb-[15px] text-[#2d2d2d] font-bold" data-id="element-175">
                ✅ Sí es para ti si...
              </h3>
              <ul className="list-none" data-id="element-176">
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-177">
                  <span className="absolute left-0" data-id="element-178">✅</span>
                  Tienes entre 45 y 65 años y sientes que algo cambió en tu
                  bienestar íntimo y quieres hacer algo al respecto
                </li>
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-179">
                  <span className="absolute left-0" data-id="element-180">✅</span>
                  Esa energía íntima que tenías parece haberse apagado sin
                  explicación
                </li>
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-181">
                  <span className="absolute left-0" data-id="element-182">✅</span>
                  Quieres apoyar tu bienestar de forma natural, sin fármacos ni
                  químicos
                </li>
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-183">
                  <span className="absolute left-0" data-id="element-184">✅</span>
                  Estás lista para dejar de ignorarlo y empezar algo que llegue
                  a la raíz
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-[8px] p-[25px]" style={{
            border: '1px solid #f0e0dc'
          }} data-id="element-185">
              <h3 className="text-[15px] mb-[15px] text-[#2d2d2d] font-bold" data-id="element-186">
                ❌ No es para ti si...
              </h3>
              <ul className="list-none" data-id="element-187">
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-188">
                  <span className="absolute left-0" data-id="element-189">❌</span>
                  Buscas una solución instantánea sin cambiar ningún hábito
                </li>
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-190">
                  <span className="absolute left-0" data-id="element-191">❌</span>
                  Necesitas atención médica urgente — consulta primero a tu
                  médico
                </li>
                <li className="text-[14px] py-[8px] leading-[1.5] pl-[20px] relative text-[#555]" style={{
                borderBottom: '1px solid #f9f0ee'
              }} data-id="element-192">
                  <span className="absolute left-0" data-id="element-193">❌</span>
                  No puedes dedicar 5 minutos diarios a tu propio bienestar
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section ref={howRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-194">
        <SectionDivider text="✦ ASÍ FUNCIONA EL PROTOCOLO ✦" data-id="element-195" />
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-[30px]" data-id="element-196">
          <div className="text-center p-[25px] rounded-[8px]" style={{
          background: '#fff5f3'
        }} data-id="element-197">
            <div className="text-[30px] mb-[10px]" data-id="element-198">1️⃣</div>
            <h3 className="text-[16px] mb-[10px] font-bold" style={{
            color: '#c4796a'
          }} data-id="element-199">
              NUTRES
            </h3>
            <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-200">
              Sigues el protocolo de hidratación y nutrición interna con los
              nutrientes específicos para esta etapa.
            </p>
          </div>
          <div className="text-center p-[25px] rounded-[8px]" style={{
          background: '#fff5f3'
        }} data-id="element-201">
            <div className="text-[30px] mb-[10px]" data-id="element-202">2️⃣</div>
            <h3 className="text-[16px] mb-[10px] font-bold" style={{
            color: '#c4796a'
          }} data-id="element-203">
              CALMAS
            </h3>
            <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-204">
              Aplicas las técnicas de respiración para reducir el cortisol y
              abrir el espacio natural al bienestar íntimo.
            </p>
          </div>
          <div className="text-center p-[25px] rounded-[8px]" style={{
          background: '#fff5f3'
        }} data-id="element-205">
            <div className="text-[30px] mb-[10px]" data-id="element-206">3️⃣</div>
            <h3 className="text-[16px] mb-[10px] font-bold" style={{
            color: '#c4796a'
          }} data-id="element-207">
              CONECTAS
            </h3>
            <p className="text-[14px] leading-[1.6] text-[#666]" data-id="element-208">
              Sigues el plan de 14 días de re-sensibilización gradual. Sin
              presión. Solo tú, reconectando contigo.
            </p>
          </div>
        </div>
      </section>

      {/* RESULTS */}
      <section ref={proofRef} className="section-fade w-full py-[50px] px-5" style={{
      background: '#fff5f3'
    }} data-id="element-209">
        <div className="max-w-[650px] mx-auto" data-id="element-210">
          <SectionDivider text="✦ LO QUE PUEDES ESPERAR ✦" data-id="element-211" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[25px] mt-5" data-id="element-212">
            <div className="rounded-[8px] p-[30px] text-center" style={{
            background: '#fff5f3'
          }} data-id="element-213">
              <div className="text-[14px] tracking-[2px] mb-[10px]" style={{
              color: '#c4796a'
            }} data-id="element-214">
                🗓️ EN LOS PRIMEROS 7 DÍAS
              </div>
              <p className="text-[15px] leading-[1.7] text-[#555]" data-id="element-215">
                Muchas mujeres que siguen el protocolo reportan sentirse más
                cómodas y con menos tensión interna. Como si algo empezara a
                despertar de nuevo.
              </p>
            </div>
            <div className="rounded-[8px] p-[30px] text-center" style={{
            background: '#fff5f3'
          }} data-id="element-216">
              <div className="text-[14px] tracking-[2px] mb-[10px]" style={{
              color: '#c4796a'
            }} data-id="element-217">
                🗓️ AL DÍA 14
              </div>
              <p className="text-[15px] leading-[1.7] text-[#555]" data-id="element-218">
                Tu cuerpo ha recibido el apoyo que necesitaba. Esa distancia que
                sentías contigo misma empieza a cerrarse.
              </p>
            </div>
          </div>
          <p className="text-center text-[12px] mt-[20px] italic" style={{
          color: '#999'
        }} data-id="element-219">
            *Los resultados varían según cada mujer. Este protocolo es
            informativo y no reemplaza la atención médica profesional.*
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section ref={faqRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-220">
        <SectionDivider text="✦ PREGUNTAS FRECUENTES ✦" data-id="element-221" />
        <FaqAccordion items={faqItems} data-id="element-222" />
      </section>

      {/* OFFER */}
      <section id="oferta" ref={offerRef} className="section-fade max-w-[650px] mx-auto py-[50px] px-5" data-id="element-223">
        <div className="rounded-[12px] p-[30px] sm:p-[50px_40px] text-center mt-[30px]" style={{
        background: '#fff5f3'
      }} data-id="element-224">
          <SectionDivider text="✦ YA ES SUFICIENTE SILENCIO ✦" data-id="element-225" />
          <p className="text-[16px] leading-[1.7] mb-[25px]" style={{
          color: '#555'
        }} data-id="element-226">
            Tu bienestar íntimo no es un lujo.
            <br data-id="element-227" />
            No es algo para después.
            <br data-id="element-228" />
            No es algo de lo que avergonzarte.
            <br data-id="element-229" />
            <br data-id="element-230" />
            <strong data-id="element-231">Es tuyo. Y lo puedes recuperar.</strong>
          </p>
          <div className="text-[18px] line-through" style={{
          color: '#aaa'
        }} data-id="element-232">
            $47.00 USD
          </div>
          <div className="text-[36px] sm:text-[48px] font-bold my-[10px]" style={{
          color: '#c4796a'
        }} data-id="element-233">
            $5.55 USD
          </div>
          <div className="text-[14px] mb-[25px]" style={{
          color: '#888'
        }} data-id="element-234">
            ⚡ Este precio no dura para siempre
          </div>

          <ul className="list-none text-left max-w-[350px] mx-auto mb-[30px]" data-id="element-235">
            <li className="py-[8px] text-[15px] text-[#555]" data-id="element-236">
              <span className="font-bold mr-1" style={{
              color: '#c4796a'
            }} data-id="element-237">
                ✓
              </span>{' '}
              Manual Digital "Libido Express" (PDF)
            </li>
            <li className="py-[8px] text-[15px] text-[#555]" data-id="element-238">
              <span className="font-bold mr-1" style={{
              color: '#c4796a'
            }} data-id="element-239">
                ✓
              </span>{' '}
              Protocolo de Nutrición de Mucosas
            </li>
            <li className="py-[8px] text-[15px] text-[#555]" data-id="element-240">
              <span className="font-bold mr-1" style={{
              color: '#c4796a'
            }} data-id="element-241">
                ✓
              </span>{' '}
              Técnica de Respiración Pélvica 60 seg
            </li>
            <li className="py-[8px] text-[15px] text-[#555]" data-id="element-242">
              <span className="font-bold mr-1" style={{
              color: '#c4796a'
            }} data-id="element-243">
                ✓
              </span>{' '}
              Plan de Acción de 14 Días
            </li>
            <li className="py-[8px] text-[15px] text-[#555]" data-id="element-244">
              <span className="font-bold mr-1" style={{
              color: '#c4796a'
            }} data-id="element-245">
                ✓
              </span>{' '}
              Guía de Hidratación Externa Segura
            </li>
          </ul>

          <a href="https://flujovital.com/cart/50801780687152:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="inline-block py-[18px] px-[40px] text-[16px] rounded-[4px] cursor-pointer tracking-[1px] mb-[20px] transition-opacity hover:opacity-90 no-underline" style={{
          background: '#c4796a',
          color: 'white',
          fontFamily: 'Georgia, serif'
        }} data-id="element-246">
            → QUIERO RECONECTARME — $5.55 USD
          </a>

          <div className="flex justify-center gap-[20px] flex-wrap text-[13px] mt-[15px]" style={{
          color: '#888'
        }} data-id="element-247">
            <span data-id="element-248">🔒 Pago 100% Seguro</span>
            <span data-id="element-249">⚡ Acceso Instantáneo</span>
            <span data-id="element-250">🔐 Total Privacidad</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="text-center py-[40px] px-5" style={{
      borderTop: '1px solid #f0e0dc'
    }} data-id="element-251">
        <div className="text-[18px] italic mb-[15px]" style={{
        color: '#c4796a'
      }} data-id="element-252">
          ✦ Lo que se apagó puede volver a encenderse. ✦
        </div>
        <p className="text-[12px] leading-[1.8]" style={{
        color: '#aaa'
      }} data-id="element-253">
          © 2025 Libido Express
          <br data-id="element-254" />
          Todos los derechos reservados
          <br data-id="element-255" />
          Contenido digital para uso personal
          <br data-id="element-256" />
          <br data-id="element-257" />
          Este producto es de carácter informativo y no reemplaza el consejo
          médico profesional. Consulta siempre a un profesional de la salud.
          <br data-id="element-258" />
          <br data-id="element-259" />
          <button onClick={() => setLegalModal('privacy')} className="underline hover:opacity-80" style={{
          color: '#c4796a'
        }} data-id="element-260">
            Política de Privacidad
          </button>{' '}
          ·{' '}
          <button onClick={() => setLegalModal('terms')} className="underline hover:opacity-80" style={{
          color: '#c4796a'
        }} data-id="element-261">
            Términos de Uso
          </button>
        </p>
      </footer>
    </div>;
}